module.exports = __webpack_public_path__ + "static/media/step6.272f8869.png";